<template>
  <div class="container info-cards">
    <div
      class="row grid-row-gap-20">
      <wave-text-block
        v-for="(block, index) in blocks"
        class="col-sm-6 col-12"
        :is_green="Boolean(blocks % 2 ? !index : index)"
        :title="block.title"
        :content="block.content"
        :key="`wave-text-block_${uid}-${index}`"
      />
    </div>
  </div>
</template>

<script>
import WaveTextBlock from "../parts/builder/WaveTextBlock.vue";
import uid_mixin from "../../mixins/uid_mixin";

export default {
  name: "InfoCards",
  components: {WaveTextBlock},
  mixins: [uid_mixin],
  props: {
    /**props**/
    blocks: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
      }
    }
    /**props**/
  },
}
</script>
